// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__qo4gJ","item":"PaymentsMobile_item__c0amj","label":"PaymentsMobile_label__3hOSF","amount":"PaymentsMobile_amount__dwUYp"};